import React from "react";
import {useNavigate} from "react-router-dom";
import {PATIENTS_ROUTE, USERS_ROUTE} from "../../../routes";
import {DATA_LIST_PAGE_SIZE} from "../../../settings";
import {PatientsList} from "../../Widgets/PatientsList/PatientsList";
import {Breadcrumbs} from "../../Widgets/Breadcrumbs/Breadcrumbs";
import {AccessType} from "../../../models/AccessType";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../../Widgets/ListItemContextMenu/ListItemContextMenu";

function Patients() {
    const history = useNavigate();
    const {menuProps, anchorPoint, targetId, onContextMenu, close} = useListContextMenu();
    const patientPath = (id: string) => `${PATIENTS_ROUTE}/${id}`;
    const patientClickHandler = (id: string) => {
        history(patientPath(id));
    };
    const userClickHandler = (id: string) => {
        history(`${USERS_ROUTE}/${id}`);
    };
    const openClickHandler = () => {
        if (targetId) {
            patientClickHandler(targetId);
        }
    };
    const openInNewTabClickHandler = () => {
        if (targetId) {
            openInNewTab(patientPath(targetId));
        }
    };
    return (
        <div>
            <Breadcrumbs/>
            <PatientsList tag="list_patients" pageSize={DATA_LIST_PAGE_SIZE} userId={null} accessType={AccessType.All}
                          patientClickHandler={patientClickHandler} contextMenuHandler={onContextMenu} userClickHandler={userClickHandler}/>
            <ListItemContextMenu menuProps={menuProps} anchorPoint={anchorPoint}
                                 onClose={close} onOpen={openClickHandler} onOpenInNewTab={openInNewTabClickHandler}/>
        </div>
    );
}

export default Patients;
